// A second full rebuild in a day asks first (planning review gap 10,
// 2026-10-24): each rebuild writes a whole new strategy (about $0.20 of the
// athlete's coach budget), and two taps on a Friday spent the day's. The
// backend's /v2/me `rebuilds_today` counts the rebuilds that reached a
// proposal since the athlete's local midnight; when it's above 0 the app asks
// "You already rebuilt your plan today — rebuild again?". Nothing is blocked:
// Rebuild again sends it, and a /v2/me that can't be read sends it too.
// A stale plan's Refresh that writes it again (body.refresh_rebuilds, from
// the backend's app/plan/staleness.py) is a rebuild too; one that only aged
// is renewed for free and goes at once.
// The same words are on mobile (lib/v2/rebuildConfirm.ts).

export const REBUILD_AGAIN = {
  title: 'You already rebuilt your plan today — rebuild again?',
  description: 'It takes your coach a minute or two to write a whole new plan.',
  confirmText: 'Rebuild again',
  cancelText: 'Not now',
};

export const isRebuild = (cmd) => cmd?.kind === 'rebuild' || (cmd?.kind === 'refresh' && Boolean(cmd.rebuilds));

/**
 * Whether to send `cmd`: true for anything that isn't a rebuild, and for a
 * rebuild when none ran today (or /v2/me can't say); else the athlete's
 * answer to `confirm(REBUILD_AGAIN)`.
 */
export async function shouldSend(cmd, { readMe, confirm }) {
  if (!isRebuild(cmd)) return true;
  let n = 0;
  try {
    const me = await readMe();
    n = Number(me?.rebuilds_today) || 0;
  } catch {
    return true;
  }
  if (n <= 0) return true;
  return Boolean(await confirm(REBUILD_AGAIN));
}
